import "./EditLocationWarningModal.scss";
import { Modal } from "antd";
import { Button } from "../misc/Button";
import {
  LocationDto, SubStatusDtoAddonsCycleEnum
} from "../../../generated/account-client";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {memberState} from "../../../state/atoms";
import AccountsApi from "../../../api/AccountsApi";
import { isDesignSubscription, isProSubscription } from "../../../service/BillingService";

export interface EditLocationWarningModalProps {
  visible: boolean;
  location: LocationDto;
  onCancel: () => void;
  onContinue: (location: LocationDto) => void;
}

export default function EditLocationWarningModal({
  location,
  visible,
  onCancel,
  onContinue,
}: EditLocationWarningModalProps) {
  const [member] = useRecoilState(memberState);
  const [locationPrice, setLocationPrice] = useState(29);

  function onAddLocation() {
    onCancel();
    if (!isProSubscription(member)) {
      if (isDesignSubscription(member)) {
        window.MHM.ProModal.switchToProWithOverview({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      } else {
        window.MHM.ProModal.upgrade({
          memberId: member.id,
          onSuccess: () => window.location.reload()
        });
      }
    } else {
      window.MHM.ProModal.addLocation({memberId: member.id, onSuccess: () => window.location.reload()})
    }
  }

  useEffect(() => {
    if (!visible || !member.id) return;
    AccountsApi.getSubscription(member.id)
      .then((resp) => {
        if (resp.data.addonsCycle === SubStatusDtoAddonsCycleEnum.Monthly) {
          setLocationPrice(35);
        } else {
          setLocationPrice(29);
        }
      })
  }, [visible, member.id]);

  return (
    <Modal
      className={"edit-location-warning-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <section>
        <header>
          <h2>Update Location</h2>
        </header>

        <p className={"message"}>
          Changes to Business Name or Address will reflect on all Link Pages and
          Online Menus for this location.
        </p>
        <p>
          <Button className={'add-location'} type={"LinkPrimary"} onClick={onAddLocation}>
            <>
            Add a Location for ${locationPrice}/month each
              </>
          </Button>
        </p>
      </section>
      <footer>
        <Button
          type={"Cancel"}
          inverted
          size={"Large"}
          onClick={() => onCancel()}
        >
          <span>Cancel</span>
        </Button>
        <Button
          type={"Primary"}
          size={"Large"}
          onClick={() => {
            onContinue(location);
          }}
        >
          <span>Continue</span>
        </Button>
      </footer>
    </Modal>
  );
}
